import styled from 'styled-components';

import {
    token,
    alphaMixin,
} from '@zillow/constellation';

import {
    Tag,
} from '@zillow/zrs-comet';

import { STATUS_TAG_TYPE } from 'app/shared/utils/statusTagUtils';

import appLogger from 'app/shared/loggers/appLogger';

const bgAlpha = 0.5;

/**
 * handleType
 *
 * @param {string} appearance
 * @param {object} colors - map to constellation colors
 *  colors is only used when applying alpha
 */
const handleType = (appearance) => {
    switch (appearance) {
        case STATUS_TAG_TYPE.PURPLE:
            return token('colors.purple600');
        default:
            appLogger.logInfo({
                message: `No case for: ${appearance}`,
                context: 'AltTag.handleType',
            });
            return alphaMixin('black', bgAlpha);
    }
};

export const StyledAltTag = styled(Tag)`
    padding: 2px 8px;
    color: ${token('colors.white')};
    /* no constellation value */
    font-size: 11px;
    border-radius: 10px;
    background-color: ${props => handleType(props.appearance)};
`;
